/* istanbul ignore file */
// not worth testing this - whole logic to scroll only
// Created custom smoothScrollTo function using react and vanilla js
// Reference: https://www.ackee.agency/blog/scroll-to-element-with-react-and-vanilla-javascript

import { MutableRefObject } from 'react'

type AnimateScrollTypes = {
  targetPosition: number
  initialPosition: number
  duration: number
}

type SmoothScrollToTypes = {
  id?: string
  ref?:
    | MutableRefObject<HTMLDivElement | null>
    | MutableRefObject<HTMLButtonElement | null>
    | MutableRefObject<HTMLHeadingElement | null>
  duration: number
}

// The easing function that makes the scroll decelerate over time
const easeOutQuart = (x: number): number => {
  return 1 - (1 - x) ** 4
}

const logError = (): void =>
  console.error(
    `Invalid element, are you sure you've provided element id or react ref?`,
  )

const animateScroll = ({
  targetPosition,
  initialPosition,
  duration,
}: AnimateScrollTypes): void | undefined => {
  let start: number | undefined
  let position: number
  let animationFrame: number

  // maximum amount of pixels we can scroll
  const maxAvailableScroll =
    document.documentElement.scrollHeight -
    document.documentElement.clientHeight

  const amountOfPixelsToScroll = initialPosition - targetPosition

  const step = (timestamp: number): void => {
    if (!start) {
      start = timestamp
    }

    const elapsed = timestamp - start

    // this just gives us a number between 0 (start) and 1 (end)
    const relativeProgress = elapsed / duration

    // ease out that number
    const easedProgress = easeOutQuart(relativeProgress)

    // calculate new position for every thick of the requestAnimationFrame
    position =
      initialPosition - amountOfPixelsToScroll * Math.min(easedProgress, 1)

    // set the scrollbar position
    window.scrollTo(0, position)

    // Stop when max scroll is reached
    if (
      initialPosition !== maxAvailableScroll &&
      window.scrollY === maxAvailableScroll
    ) {
      cancelAnimationFrame(animationFrame)
      return
    }

    // repeat until the end is reached
    if (elapsed < duration) {
      animationFrame = requestAnimationFrame(step)
    }
  }

  animationFrame = requestAnimationFrame(step)
}

export const smoothScrollTo = ({
  id,
  ref,
  duration = 3000,
}: SmoothScrollToTypes): void => {
  // the position of the scroll bar before the user clicks the button
  const initialPosition = window.scrollY

  const getElementPosition = (element: HTMLElement): number =>
    element.getBoundingClientRect().top + initialPosition
  // decide what type of reference that is
  // if neither ref or id is provided set element to null
  let element
  if (!ref && !id) {
    element = null
  } else if (ref) {
    element = ref.current
  } else if (id) {
    element = document.getElementById(id)
  }

  if (!element) {
    // log error if the reference passed is invalid
    logError()
    return
  }

  animateScroll({
    targetPosition: getElementPosition(element),
    initialPosition,
    duration,
  })
}
